// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { useLocation } from '@tanstack/react-router';

// material ui icons
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

// material ui
import { Box, Link, Typography } from '@mui/material';

// shared components
import PageContainer from '@/components/layout/PageContainer';

export default function AppFooter() {
  const { t } = useTranslation();
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const companyName = 'ReMoni';
  const copyrightText = `Copyright © ${currentYear} `;

  if (location.pathname.includes('energy-breakdown')) {
    return null;
  }

  return (
    <Box component="footer">
      <PageContainer
        maxWidth="xl"
        sx={{
          py: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <Typography variant="caption" sx={{ opacity: 0.6 }}>
          {copyrightText}
          <Link
            href="https://remoni.com"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{ color: 'inherit' }}
          >
            {companyName}
          </Link>
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Link
            href="mailto:support@remoni.com"
            aria-label={t('appLayout.footer.contact')}
            sx={{
              display: 'inline-flex',
              color: 'text.secondary',
              opacity: 0.85,
              ':hover': {
                color: 'text.primary',
              },
            }}
          >
            <EmailIcon fontSize="small" />
          </Link>
          <Link
            href="https://www.linkedin.com/company/3480978/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-flex',
              color: 'text.secondary',
              opacity: 0.85,
            }}
          >
            <LinkedInIcon fontSize="small" />
          </Link>
          <Link
            href="https://www.youtube.com/channel/UCAzO6Ew65onCl72Xo6y8gAw"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-flex',
              color: 'text.secondary',
              opacity: 0.85,
              ':hover': {
                color: 'error.main',
              },
            }}
          >
            <YouTubeIcon fontSize="small" />
          </Link>
        </Box>
      </PageContainer>
    </Box>
  );
}
